import { appRoute } from "routes/app/home.runtime"
import { RootPlugs, ShareLinkOtherSettings } from "slot-definitions"
import { getSharingLinks } from "routes/sharing/controller/get-sharing-links"
import { useEffect } from "react"
import { RefreshNavBar } from "event-definitions"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { hasDemand } from "lib/authorization/has-demand"
import { Lazy } from "lib/make-lazy"
import { registerFeature, registerFeatureWithDescription } from "lib/features"
import { ExposeZeroUShareLinkSetting } from "routes/sharing/zero-u-setting"
import { UseUniqueCodeShareLinkSetting } from "routes/sharing/unique-code-setting"
import { FEATURE_FLAG_API_EXPOSE_ZEROU, FEATURE_FLAG_API_USE_UNIQUE_CODE } from "./api-feature-flags"
// Side-effect import so the wizard flag's registerFeatureWithDescription() runs at startup and the
// flag shows in the admin Feature Flags screen. Its only other importers (new-share-link.js /
// share-settings.js) load lazily with the Sharing page, so without this it never registers eagerly.
import "./feature-flag-share-link-wizard"
import { isEnabled } from "lib/@components/feature"

appRoute.register("sharing", <Lazy importer={() => import("routes/sharing/sharing")} extract="Sharing" />)

export const FEATURE_FLAG_COMPANION_TASKS = registerFeature({
    numericalId: 9,
    name: "Companion Tasks",
    id: "companionTasks",
    description: `Enables the system to create sharing links that have user checks in them, currently not to be used in production.`,
})

export const FEATURE_FLAG_SHARE_LINK_DISTRIBUTION = registerFeatureWithDescription({
    numericalId: 21,
    id: "shareLinkDistribution",
    name: "Share-Link Distribution",
    readyForProduction: true,
    descriptionLines: [
        "Allows entitled clients to distribute share links to registered recipients without paid SFG20 licences.",
    ],
})

RootPlugs.plug(<HasSharing />)

let hasLinks = false

function HasSharing() {
    const links = getSharingLinks.useResults({ take: 0 }) ?? null

    hasLinks = !!links?.total
    useEffect(() => {
        RefreshNavBar.raiseOnce()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasLinks])
    return null
}

registerConditionalPageNavigation(
    () => hasLinks && hasDemand("canMakeShare"),
    "/app/sharing",
    "Sharing Links",
    "material-symbols:share",
    {
        group: "Planning",
        priority: 155,
    }
)

ShareLinkOtherSettings("Api").plug(<ExposeZeroUShareLinkSetting if={() => isEnabled(FEATURE_FLAG_API_EXPOSE_ZEROU)} />)
ShareLinkOtherSettings("Api").plug(
    <UseUniqueCodeShareLinkSetting if={() => isEnabled(FEATURE_FLAG_API_USE_UNIQUE_CODE)} />
)
